import React, { useEffect, useState } from 'react';
import swal from 'sweetalert2';
import moment from 'moment';
import * as XLSX from 'xlsx';
import noData from '../assets/images/no-data.png';
import ReactTooltip from "react-tooltip";
import { saveAs } from 'file-saver';
import { getMIS } from './api/dashboardAPI';


const MIS = (props) => {

    const [search,              setSearch]              = useState('');
    const [type,                setType]                = useState('All');
    const [testType,            setTestType]            = useState('All');
    const [status,              setStatus]              = useState('All');
    const [tpa,                 setTPA]                 = useState(0);
    const [doctor,              setDoctor]              = useState(0);
    const [from,                setFrom]                = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [to,                  setTo]                  = useState(moment().endOf('month').format('YYYY-MM-DD'));
    const [doctorList,          setDoctorList]          = useState([]);
    const [clients,             setClients]             = useState([]);
    const [filteredClients,     setFilteredClients]     = useState([]);

    useEffect(() => {
        fetchClients();     
    }, [from, to])

    useEffect(() => {
        let filtered = [];
        if (search) {
            //filter as per searched
            filtered = clients.filter(m => {
                let matchString = `${m.ProposalNo} ${m.Client} ${m.Division} ${m.BranchCode}`;
                let matchFound  = 0;
                var searchArr   = search.split(' ');
                
                searchArr.forEach(t => matchFound += matchString.toLowerCase().includes(t.toLowerCase()) ? 1 : 0);

                return matchFound === searchArr.length;
            });
        }else{
            filtered = clients;
        }

        if (type != 'All') {
            filtered = filtered.filter(f => f.Type == type);
        }

        if (testType != 'All') {
            filtered = filtered.filter(f => f.TestType == testType);
        }

        if (status != 'All') {
            filtered = filtered.filter(f => f.Status == status);
        }

        if (tpa != 0) {
            filtered = filtered.filter(f => f.TPAID == tpa);
        }

        if (doctor != 0) {
            filtered = filtered.filter(f => f.DoctorID == doctor);
        }

        setFilteredClients(filtered);

    }, [search, type, testType, status, tpa, doctor])

    const fetchClients = async() => {
        try {
            swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });
            const { Clients, Doctors } = await getMIS(from, to);
            setClients(Clients);
            setFilteredClients(Clients);
            setDoctorList(Doctors);
            swal.close();
        } catch (err) {
            swal.close();
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            return;  
        }
    }

    const downloadExcel = () => {
        if (filteredClients.length === 0) {
            swal.fire({ icon: "warning", title: "<small>No data available to export</small>"});
            return;
        }

        // Define custom headers with spaces
        const customHeaders = {
            TestType        : "Test",
            ProposalNo      : "Proposal No",
            Type            : "Type",
            CreatedDate     : "Date Received",
            Date            : "Medical Date",
            Client          : "Client",
            Doctor          : "Doctor",
            TPA             : "TPA",
            Division        : "Division",
            BranchCode      : "Branch",
            Status          : "Status"
        };

        // Convert JSON data to array format with custom headers
        const formattedData = filteredClients.map(client => {
            let formattedObj = {};
            Object.keys(customHeaders).forEach(key => {
                formattedObj[customHeaders[key]] =
                    client[key] ? (key === "CreatedDate" || key === "Date" ? moment(client[key]).format("DD-MMM-YYYY") : client[key]) : "";
            });
            return formattedObj;
        });

        // Convert JSON data to a worksheet
        const worksheet = XLSX.utils.json_to_sheet([]);

         // Add headers
        const headerRow = Object.values(customHeaders);
        XLSX.utils.sheet_add_aoa(worksheet, [headerRow], { origin: "A1" });

        // Add an empty row after headers
        XLSX.utils.sheet_add_aoa(worksheet, [[]], { origin: "A2" });

        // Add actual data starting from row 3
        XLSX.utils.sheet_add_json(worksheet, formattedData, { origin: "A3", skipHeader: true });

        // Auto-adjust column widths
        const columnWidths = headerRow.map(header => ({
            wch: Math.max(
                header.length,
                ...filteredClients.map(client => (client[header] ? client[header].toString().length : 10))
            ) + 2 // Adding padding
        }));
        worksheet["!cols"] = columnWidths; // Apply column widths

        // Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    
        // Generate Excel file and trigger download
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        saveAs(data, `Medical-Report-${moment().format("DD-MMM-YYYY")}.xlsx`);
    };
    

    return ( 
        <>
            <div className='container margin-t58'> 
                <div className='row mb-4'>
                    <div className='col-lg-3 mt-3'>
                        <div className='input-group'>
                            <span className='input-group-text fs-16'><i className="bi bi-search"></i></span>
                            <input 
                                onChange={({ target }) => setSearch(target.value)}
                                value={ search || '' }
                                className="form-control fs-16" 
                                type="search" 
                                placeholder="Search"
                            />
                        </div>
                    </div>
                    <div className='col-lg-3 mt-3'>
                        <div className='input-group'>
                            <span className='input-group-text fs-16'>From</span>
                            <input
                                type="date" 
                                className="form-control"
                                value={from || ''}
                                onChange={({ target }) => setFrom(target.value)}

                            />
                        </div>
                    </div>
                    <div className='col-lg-3 mt-3'>
                        <div className='input-group'>
                            <span className='input-group-text fs-16'>To</span>
                            <input
                                type="date" 
                                className="form-control" 
                                value={to || ''}
                                onChange={({ target }) => setTo(target.value)}
                            />
                        </div>
                    </div>
                     <div className='col-lg-3 mt-3'>
                        <div className='input-group'>
                            <span className='input-group-text fs-16'>Type</span>
                            <select value={type} onChange={({ target }) => setType(target.value)} className="form-select fs-16">
                                <option value={'All'}>All</option>
                                <option value={'NB'}>NB</option>
                                <option value={'Revival'}>Revival</option>
                                <option value={'PWB'}>PWB</option>
                                <option value={'Outstation'}>Outstation</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-lg-3 mt-3'>
                        <div className='input-group'>
                            <span className='input-group-text fs-16'>TPA</span>
                            <select value={tpa} onChange={({ target }) => setTPA(target.value)} className="form-select fs-16">
                                <option value={0}>All</option>
                                {props.tpaList.length > 0 && props.tpaList.map(m => (
                                    <option key={m.ID} value={m.ID}>{m.Name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className='col-lg-3 mt-3'>
                        <div className='input-group'>
                            <span className='input-group-text fs-16'>Doctor</span>
                            <select value={doctor} onChange={({ target }) => setDoctor(target.value)} className="form-select fs-16">
                                <option value={0}>All</option>
                                {doctorList.length > 0 && doctorList.map(m => (
                                    <option key={m.ID} value={m.ID}>{m.Name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className='col-lg-3 mt-3'>
                        <div className='input-group'>
                            <span className='input-group-text fs-16'>Status</span>
                            <select value={status} onChange={({ target }) => setStatus(target.value)} className="form-select fs-16">
                                    <option value={'All'}>All</option>
                                    <option value={'Pending'}>Pending</option>
                                    <option value={'Assigned'}>Assigned</option>
                                    <option value={'Scheduled'}>Scheduled</option>
                                    <option value={'QC Pending'}>QC Pending</option>
                                    <option value={'Success'}>Success</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-lg-2 mt-3'>
                        <div className='input-group'>
                            <span className='input-group-text fs-16'>Test</span>
                            <select value={testType} onChange={({ target }) => setTestType(target.value)} className="form-select fs-16">
                                <option value={'All'}>All</option>
                                <option value={'VMER'}>VMER</option>
                                <option value={'JMER'}>JMER</option>
                                <option value={'TMER'}>TMER</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-lg-1 mt-3'>
                        <button onClick={downloadExcel} type="button" className="btn btn-outline-info w-100"><i className="bi bi-download"></i></button>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-12'>
                        <table className="table table-bordered">
                            <thead>
                                <tr className='text-center'>
                                    <th colSpan={11}><span className='badge rounded-pill bg-success'>Total Medicals: {filteredClients.length}</span></th>
                                </tr>
                                <tr>
                                    <th>Test</th>
                                    <th>Proposal No</th>
                                    <th>Type</th>
                                    <th>Date Received</th>
                                    <th>Medical Date</th>
                                    <th>Client</th>
                                    <th>Doctor</th>
                                    <th>TPA</th>
                                    <th>Division</th>
                                    <th>Branch</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredClients.length > 0 ? (
                                    <>
                                        {filteredClients.map((m, i) => (
                                            <tr key={m.ID}>
                                                <td><span className={`badge bg-${m.TestType == 'VMER' ? 'primary' : 'info'} me-2`}>{m.TestType}</span></td>
                                                <td>
                                                    <span data-tip={m.ProposalNo}>{m.ProposalNo}</span>
                                                </td>
                                                <td>
                                                    <span data-tip={m.Type}>{m.Type}</span>
                                                </td>
                                                <td>
                                                    <span data-tip={moment(m.CreatedDate).format('DD-MMM-YYYY')}>{moment(m.CreatedDate).format('DD-MMM-YYYY')}</span>
                                                </td>
                                                <td>
                                                    <span data-tip={m.Date ? moment(m.Date).format('DD-MMM-YYYY') : ''}>{m.Date ? moment(m.Date).format('DD-MMM-YYYY') : ''}</span>
                                                </td>
                                                <td>
                                                    <span data-tip={m.Client}>{m.Client}</span>
                                                </td>
                                                <td>
                                                    <span data-tip={m.Doctor}>{m.Doctor}</span>
                                                </td>
                                                <td>
                                                    <span data-tip={m.TPA}>{m.TPA}</span>
                                                </td>
                                                <td>
                                                    <span data-tip={m.Division}>{m.Division}</span>
                                                </td>
                                                <td>
                                                    <span data-tip={m.BranchCode}>{m.BranchCode}</span>
                                                </td>
                                                <td><span className={`badge rounded-pill bg-${m.Status == 'Success' ? 'success' : m.Status == 'QC Pending' ? 'info' : m.Status == 'Scheduled' ? 'primary' : m.Status == 'Assigned' ? 'secondary' : 'warning'} me-5`}>{m.Status}</span></td>
                                            </tr>
                                        ))}
                                        <ReactTooltip place="right" effect="solid" />
                                    </>
                                ) : (
                                    <tr>
                                        <td colSpan={11}>
                                            <div className='text-center mt-5'>
                                                <img src={noData} alt="image"  height="100"/>
                                                <h6 className='mt-3'>No records found!</h6>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>


        </>
    )
}

export default MIS;